<script setup lang="ts"></script>

<template>
  <div class="w-full flex justify-end items-end p-4">
    <DarkModeToggle />
  </div>
  <div class="flex items-center h-full w-full">
    <main class="flex flex-col w-full items-center gap-4 p-4 lg:p-2">
      <slot />
    </main>
  </div>
</template>
